import {getFeatureFlag} from '../../feature-flags';

export function hasEmailSequenceAutomation(): boolean {
    return Boolean(getFeatureFlag('hasEmailSequencesSalesAutomation'));
}
